import React from 'react'

import {
  Sheet,
  SheetCloseButton,
  SheetOverlay,
  SheetContent,
  SheetTitle,
} from '@wartek-id/sheet-v1'

import { useProfile } from 'app/ProfileRevampPage/hooks/useProfile'

interface ISubjectsDrawerProps {
  isOpen: boolean
  onClose: () => void
  onCloseButtonClicked: () => void
}

export const SubjectsDrawer = ({
  isOpen,
  onClose,
  onCloseButtonClicked,
}: ISubjectsDrawerProps) => {
  const { profileData } = useProfile()
  return (
    <Sheet isOpen={isOpen} onClose={onClose} autoFocus={false} sheetSize="auto">
      <SheetOverlay />
      <SheetContent className="max-w-xl m-auto !z-[1000]">
        <SheetCloseButton onClick={onCloseButtonClicked} />
        <SheetTitle bold bordered>
          Mata Pelajaran
        </SheetTitle>
        <div data-testid="profile-subjects-all" className="px-3 py-4">
          <ul className="list-disc ml-6">
            {(profileData.subjects ?? []).map((subject, index) => (
              <li key={`profile-subject-item-${index}`}>
                <div className="truncate">{subject}</div>
              </li>
            ))}
          </ul>
        </div>
      </SheetContent>
    </Sheet>
  )
}
